/**
 * PDP: expand Vitals description panels; bind #ProductReviews to Reputon;
 * hide only legacy AReviews widgets (do not touch product info / Reputon).
 */
(function () {
  function findReviewsPanel() {
    return (
      document.getElementById('ProductReviews') ||
      document.querySelector('.fp-amazon-reviews') ||
      document.querySelector('.section-fp-amazon-reviews')
    );
  }

  function hideLegacyAreviews() {
    document
      .querySelectorAll('.vtl-pr-main-widget, #az_reviews, .AReviewsApp, .az_reviews, #fp-pdp-reviews-heading')
      .forEach(function (el) {
        if (el.closest('#ProductReviews, .fp-amazon-reviews, .section-fp-amazon-reviews')) return;
        el.style.setProperty('display', 'none', 'important');
      });
  }

  function bindAnchor() {
    var panel = findReviewsPanel();
    if (!panel) return false;

    document.querySelectorAll('#ProductReviews').forEach(function (el) {
      if (el !== panel) el.removeAttribute('id');
    });
    if (panel.id !== 'ProductReviews') panel.id = 'ProductReviews';
    return true;
  }

  function forceExpandPanels() {
    document
      .querySelectorAll('#vitals-tabs-placeholder .vt-panel, #vitals-tabs-placeholder .vt-tab-content')
      .forEach(function (el) {
        // Never collapse product description panels
        el.style.setProperty('display', 'block', 'important');
        el.style.setProperty('visibility', 'visible', 'important');
        el.style.setProperty('height', 'auto', 'important');
      });
  }

  function scrollIfNeeded() {
    if (window.location.hash !== '#ProductReviews') return;
    var target = findReviewsPanel();
    if (!target) return;
    requestAnimationFrame(function () {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function boot() {
    forceExpandPanels();
    hideLegacyAreviews();
    bindAnchor();
    scrollIfNeeded();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('hashchange', function () {
    forceExpandPanels();
    hideLegacyAreviews();
    bindAnchor();
    scrollIfNeeded();
  });

  document.addEventListener(
    'click',
    function (event) {
      var writeLink = event.target.closest(
        'a[href="#ProductReviewsWrite"], a[href$="#ProductReviewsWrite"], [data-fp-write-review]'
      );
      if (writeLink) {
        forceExpandPanels();
        bindAnchor();
        return;
      }

      var link = event.target.closest(
        'a[href="#ProductReviews"], a[href$="#ProductReviews"], a[href="#ProductReviewsList"], a[href$="#ProductReviewsList"]'
      );
      if (!link) return;
      forceExpandPanels();
      bindAnchor();
      var target =
        (link.getAttribute('href') || '').indexOf('ProductReviewsList') !== -1
          ? document.getElementById('ProductReviewsList') || findReviewsPanel()
          : findReviewsPanel();
      if (!target) return;
      event.preventDefault();
      var hash = target.id ? '#' + target.id : '#ProductReviews';
      if (history.replaceState) history.replaceState(null, '', hash);
      else window.location.hash = hash.replace('#', '');
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    true
  );

  var observer = new MutationObserver(function () {
    forceExpandPanels();
    hideLegacyAreviews();
    bindAnchor();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () {
    observer.disconnect();
  }, 20000);
})();
